import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import * as Yup from "yup"
import { Alert, Box, Button, Snackbar, TextField, Typography } from '@mui/material';
import FieldWithLabel from '../FieldWithLabel';
import QuillEditor from '../QuillEditor';
import { useLoader } from '../../context/loaderContext';
import { saveTermContent, getTermContent } from '../../api/bergabung';

interface FormData {
  term_title: {
    id: string;
    en: string;
  };
  term_article: {
    id: string;
    en: string;
  }
}

const validationSchema = Yup.object({
  term_title: Yup.object().shape({
    id: Yup.string().nullable(''),
    en: Yup.string().nullable(''),
  }),
  term_article: Yup.object().shape({
    id: Yup.string().nullable(''),
    en: Yup.string().nullable(),
  }),
})

const defaultValues = {
  term_title: {
    id: "",
    en: "",
  },
  term_article: {
    id: "",
    en: "",
  }
}


export default function Term() {
  const { showLoader, hideLoader } = useLoader()
  const [isEdit, setIsEdit] = useState(false)

  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
  }>({
    open: false,
    message: "",
    severity: "success",
  });

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const {
    register: registerTerm,
    handleSubmit: handleSubmitTerm,
    setValue: setValTerm,
    getValues: getValTerm,
    watch: watchTerm,
    formState: { errors: errorsTerm },
    control: controlTerm,
  } = useForm<FormData>({
    //@ts-ignore
    resolver: yupResolver(validationSchema),
    defaultValues: isEdit ? undefined : defaultValues,
  });

  const onSubmitTerm = async (data: FormData) => {
    try {
      const payload = { ...data }
      const resSaveTerm = await saveTermContent(payload)
      if (!resSaveTerm.status) {
        setSnackbar({
          open: true,
          message: "Konten artikel gagal disimpan",
          severity: "error",
        });
        return
      }

      setSnackbar({
        open: true,
        message: "Konten artikel berhasil disimpan",
        severity: "success",
      });
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    showLoader()
    getTermContent().then((res: any) => {
      if (res.status) {
        setValTerm('term_title.id', res?.data.term_title.id)
        setValTerm('term_title.en', res?.data.term_title.en)
        setValTerm('term_article.id', res?.data.term_article.id)
        setValTerm('term_article.en', res?.data.term_article.en)
        setIsEdit(true)
      }
    })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        hideLoader()
      })
  }, [])

  return (
    <>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <form
        onSubmit={handleSubmitTerm(onSubmitTerm)}
        className="w-full flex flex-col gap-y-4 mt-4"
      >
        <div className='mb-8'>
          <FieldWithLabel label="Judul (Bahasa Indonesia)" required>
            <TextField
              {...registerTerm("term_title.id")}
              error={!!errorsTerm?.term_title?.id}
              helperText={errorsTerm?.term_title?.id?.message}
            />
          </FieldWithLabel>
          <FieldWithLabel label="Artikel (Bahasa Indonesia)" required applyMargin={true}>
            <Box>
              <QuillEditor name="term_article.id" control={controlTerm} />
            </Box>
          </FieldWithLabel>
        </div>
        <div>
          <FieldWithLabel label="Judul (Bahasa Ingrris)" required>
            <TextField
              {...registerTerm("term_title.en")}
              error={!!errorsTerm?.term_title?.en}
              helperText={errorsTerm?.term_title?.en?.message}
            />
          </FieldWithLabel>
          <FieldWithLabel label="Artikel (Bahasa Inggris)" required applyMargin={true}>
            <Box>
              <QuillEditor name="term_article.en" control={controlTerm} />
            </Box>
          </FieldWithLabel>
        </div>
        <div className="flex justify-end mt-4">
          <Button type="submit" className="!w-fit">
            <Typography textTransform={"capitalize"}>
              Simpan
            </Typography>
          </Button>
        </div>
      </form>
    </>
  )
}
